let isFunction = function (obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply)
}

const chunk = (arr, chunkSize, cache = []) => {
  const tmp = [...arr]
  while (tmp.length) cache.push(tmp.splice(0, chunkSize))
  return cache
}

const generateId = () => {
  return Math.random()
    .toString(10)
    .substring(10)
}

const isString = (value) => {
  return typeof value === 'string'
}

let copyMyProps = (propTypes) => (props) => {
  if (!propTypes) return null
  if (!props) return {}
  let propKeys = Object.keys(props)
  let filtered = propKeys
    .filter(t => propTypes.hasOwnProperty(t))
    .reduce((acc, key) => {
      acc[key] = props[key]
      return acc
    }, {})
  return filtered
}

/**
 * Native implementation of lodash _.pick()
 * @param object
 * @param keys
 * @returns {*}
 */
const pick = (object, keys) => keys.reduce((obj, key) => {
  if (object && object.hasOwnProperty(key)) {
    obj[key] = object[key]
  }
  return obj
}, {})

export { isFunction, chunk, generateId, isString, copyMyProps, pick }
